import React from 'react';
import { GiftIcon, PrinterIcon, LayersIcon, HandIcon, LifeBuoyIcon, AwardIcon } from 'lucide-react';
const bonuses = [{
  icon: PrinterIcon,
  title: 'Schede Operative Stampabili',
  price: '19 €'
}, {
  icon: LayersIcon,
  title: 'Flashcard Musicali: Notazione e Ritmo',
  price: '19 €'
}, {
  icon: HandIcon,
  title: 'Musica Senza Strumenti: 40 Attività',
  price: '27 €'
}, {
  icon: LifeBuoyIcon,
  title: "Il Kit di Sopravvivenza per l'Insegnante Non Musicista",
  price: '36 €'
}, {
  icon: AwardIcon,
  title: 'Verifiche e Certificati Pronti da Stampare',
  price: '27 €'
}];
export function Bonuses() {
  return <section className="w-full bg-cream-deep px-5 py-16 sm:py-24" data-id="element-50" data-mp="3t06gsugceb9h">
      <div className="mx-auto max-w-3xl" data-id="element-51" data-mp="3t2j6jtscdpx3">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.22em] text-orange sm:text-xs" data-id="element-52" data-mp="1m9yvtb7sksx0">
          Offerta a tempo limitato
        </p>
        <h2 className="mt-4 flex items-center justify-center gap-3 text-center text-[26px] font-extrabold tracking-tight text-navy sm:text-4xl" data-id="element-53" data-mp="1r6yz5ed9bhkf">
          <GiftIcon className="h-6 w-6 flex-none text-orange sm:h-7 sm:w-7" aria-hidden="true" data-id="element-54" data-mp="3deaepkcm6eh6" />
          5 Bonus Esclusivi
        </h2>
        <p className="mt-4 text-center text-base text-ink-soft sm:text-lg" data-id="element-55" data-mp="3r8uk2ynrn3g9">
          Valore totale: <span className="font-semibold text-navy" data-id="element-56" data-mp="3n5y7bokwq1k8">128 €</span> — inclusi
          gratuitamente nel pack di oggi
        </p>

        <ol className="mt-10 space-y-4" data-id="element-57" data-mp="2ughameq97yi7">
          {bonuses.map(({
          icon: Icon,
          title,
          price
        }, index) => <li key={title} className="flex items-center gap-4 rounded-3xl border border-navy/10 bg-white p-5 sm:gap-5" data-id="element-58" data-mp="38g0ir7j2f9ui" data-mpi={index}>
              <span className="flex h-8 w-8 flex-none items-center justify-center rounded-full bg-navy text-sm font-bold text-white" data-id="element-59" data-mp="33ja1igviy87i">
                {index + 1}
              </span>
              <span className="flex h-12 w-12 flex-none items-center justify-center rounded-2xl bg-grape-tint" data-id="element-60" data-mp="iqewelaghehi">
                <Icon className="h-5 w-5 text-grape" aria-hidden="true" data-id="element-61" data-mp="3cimwwpwxsq7n" />
              </span>
              <h3 className="min-w-0 flex-1 text-[15px] font-bold leading-snug text-navy sm:text-base" data-id="element-62" data-mp="3hg6e9yoxlj3t">
                {title}
              </h3>
              <p className="flex flex-none flex-col items-end gap-1 text-right" data-id="element-63" data-mp="3qj7j7w22945w">
                <span className="text-xs text-ink-soft line-through" data-id="element-64" data-mp="2tsf34yf4nc44">{price}</span>
                <span className="rounded-full bg-orange px-3 py-1 text-[10px] font-extrabold uppercase tracking-[0.12em] text-white" data-id="element-65" data-mp="2tqc4jpzwsans">
                  Gratis
                </span>
              </p>
            </li>)}
        </ol>
      </div>
    </section>;
}